// Simple Set Clipboard System
// Author: Joseph Huckaby

var ZeroClipboard_TableTools = {

    version: "1.0.4-TableTools2",
    clients: {}, // registered upload clients on page, indexed by id
    moviePath: '', // URL to movie
    nextId: 1, // ID of next movie

    $: function (thingy) {
        // simple DOM lookup utility function
        if (typeof(thingy) == 'string') thingy = document.getElementById(thingy);
        if (!thingy.addClass) {
            // extend element with a few useful methods
            thingy.hide = function () {
                this.style.display = 'none';
            };
            thingy.show = function () {
                this.style.display = '';
            };
            thingy.addClass = function (name) {
                this.removeClass(name);
                this.className += ' ' + name;
            };
            thingy.removeClass = function (name) {
                this.className = this.className.replace(new RegExp("\\s*" + name + "\\s*"), " ").replace(/^\s+/, '').replace(/\s+$/, '');
            };
            thingy.hasClass = function (name) {
                return !!this.className.match(new RegExp("\\s*" + name + "\\s*"));
            }
        }
        return thingy;
    },

    setMoviePath: function (path) {
        // set path to ZeroClipboard.swf
        this.moviePath = path;
    },

    dispatch: function (id, eventName, args) {
        // receive event from flash movie, send to client
        var client = this.clients[id];
        if (client) {
            client.receiveEvent(eventName, args);
        }
    },

    register: function (id, client) {
        // register new client to receive events
        this.clients[id] = client;
    },

    getDOMObjectPosition: function (obj) {
        // get absolute coordinates for dom element
        var info = {
            left: 0,
            top: 0,
            width: obj.width ? obj.width : obj.offsetWidth,
            height: obj.height ? obj.height : obj.offsetHeight
        };

        if (obj.style.width != "")
            info.width = obj.style.width.replace("px", "");

        if (obj.style.height != "")
            info.height = obj.style.height.replace("px", "");

        while (obj) {
            info.left += obj.offsetLeft;
            info.top += obj.offsetTop;
            obj = obj.offsetParent;
        }

        return info;
    },

    Client: function (elem) {
        // constructor for new simple upload client
        this.handlers = {};

        // unique ID
        this.id = ZeroClipboard_TableTools.nextId++;
        this.movieId = 'ZeroClipboard_TableToolsMovie_' + this.id;

        // register client with singleton to receive flash events
        ZeroClipboard_TableTools.register(this.id, this);

        // create movie
        if (elem) this.glue(elem);
    }
};

ZeroClipboard_TableTools.Client.prototype = {

    id: 0, // unique ID for us
    ready: false, // whether movie is ready to receive events or not
    movie: null, // reference to movie object
    clipText: '', // text to copy to clipboard
    fileName: '', // default file save name
    action: 'copy', // action to perform
    handCursorEnabled: true, // whether to show hand cursor, or default pointer cursor
    cssEffects: true, // enable CSS mouse effects on dom container
    handlers: null, // user event handlers
    sized: false,

    glue: function (elem, title) {
        // glue to DOM element
        // elem can be ID or actual DOM element object
        this.domElement = ZeroClipboard_TableTools.$(elem);

        // float just above object, or zIndex 99 if dom element isn't set
        var zIndex = 99;
        if (this.domElement.style.zIndex) {
            zIndex = parseInt(this.domElement.style.zIndex) + 1;
        }

        // find X/Y position of domElement
        var box = ZeroClipboard_TableTools.getDOMObjectPosition(this.domElement);

        // create floating DIV above element
        this.div = document.createElement('div');
        var style = this.div.style;
        style.position = 'absolute';
        style.left = '0px';
        style.top = '0px';
        style.width = (box.width) + 'px';
        style.height = box.height + 'px';
        style.zIndex = zIndex;

        if (typeof title != "undefined" && title != "") {
            this.div.title = title;
        }
        if (box.width != 0 && box.height != 0) {
            this.sized = true;
        }

        // style.backgroundColor = '#f00'; // debug
        if (this.domElement) {
            this.domElement.appendChild(this.div);
            this.div.innerHTML = this.getHTML(box.width, box.height);
        }
    },

    positionElement: function () {
        var box = ZeroClipboard_TableTools.getDOMObjectPosition(this.domElement);
        var style = this.div.style;

        style.position = 'absolute';
        //style.left = (this.domElement.offsetLeft)+'px';
        //style.top = this.domElement.offsetTop+'px';
        style.width = box.width + 'px';
        style.height = box.height + 'px';

        if (box.width != 0 && box.height != 0) {
            this.sized = true;
        } else {
            return;
        }

        var flash = this.div.childNodes[0];
        flash.width = box.width;
        flash.height = box.height;
    },

    getHTML: function (width, height) {
        // return HTML for movie
        var html = '';
        var flashvars = 'id=' + this.id +
            '&width=' + width +
            '&height=' + height;

        if (navigator.userAgent.match(/MSIE/)) {
            // IE gets an OBJECT tag
            var protocol = location.href.match(/^https/i) ? 'https://' : 'http://';
            html += '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="' + protocol + 'download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=10,0,0,0" width="' + width + '" height="' + height + '" id="' + this.movieId + '" align="middle"><param name="allowScriptAccess" value="always" /><param name="allowFullScreen" value="false" /><param name="movie" value="' + ZeroClipboard_TableTools.moviePath + '" /><param name="loop" value="false" /><param name="menu" value="false" /><param name="quality" value="best" /><param name="bgcolor" value="#ffffff" /><param name="flashvars" value="' + flashvars + '"/><param name="wmode" value="transparent"/></object>';
        }
        else {
            // all other browsers get an EMBED tag
            html += '<embed id="' + this.movieId + '" src="' + ZeroClipboard_TableTools.moviePath + '" loop="false" menu="false" quality="best" bgcolor="#ffffff" width="' + width + '" height="' + height + '" name="' + this.movieId + '" align="middle" allowScriptAccess="always" allowFullScreen="false" type="application/x-shockwave-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" flashvars="' + flashvars + '" wmode="transparent" />';
        }
        return html;
    },

    hide: function () {
        // temporarily hide floater offscreen
        if (this.div) {
            this.div.style.left = '-2000px';
        }
    },

    show: function () {
        // show ourselves after a call to hide()
        this.reposition();
    },

    destroy: function () {
        // destroy control and floater
        if (this.domElement && this.div) {
            this.hide();
            this.div.innerHTML = '';

            var body = document.getElementsByTagName('body')[0];
            try {
                body.removeChild(this.div);
            } catch (e) {
                ;
            }

            this.domElement = null;
            this.div = null;
        }
    },

    reposition: function (elem) {
        // reposition our floating div, optionally to new container
        // warning: container CANNOT change size, only position
        if (elem) {
            this.domElement = ZeroClipboard_TableTools.$(elem);
            if (!this.domElement) this.hide();
        }

        if (this.domElement && this.div) {
            var box = ZeroClipboard_TableTools.getDOMObjectPosition(this.domElement);
            var style = this.div.style;
            style.left = '' + box.left + 'px';
            style.top = '' + box.top + 'px';
        }
    },

    clearText: function () {
        // clear the text to be copy / saved
        this.clipText = '';
        if (this.ready) this.movie.clearText();
    },

    appendText: function (newText) {
        // append text to that which is to be copied / saved
        this.clipText += newText;
        if (this.ready) {
            this.movie.appendText(newText);
        }
    },

    setText: function (newText) {
        // set text to be copied to be copied / saved
        this.clipText = newText;
        if (this.ready) {
            this.movie.setText(newText);
        }
    },

    setCharSet: function (charSet) {
        // set the character set (UTF16LE or UTF8)
        this.charSet = charSet;
        if (this.ready) {
            this.movie.setCharSet(charSet);
        }
    },

    setBomInc: function (bomInc) {
        // set if the BOM should be included or not
        this.incBom = bomInc;
        if (this.ready) {
            this.movie.setBomInc(bomInc);
        }
    },

    setFileName: function (newText) {
        // set the file name
        this.fileName = newText;
        if (this.ready) this.movie.setFileName(newText);
    },

    setAction: function (newText) {
        // set action (save or copy)
        this.action = newText;
        if (this.ready) this.movie.setAction(newText);
    },

    addEventListener: function (eventName, func) {
        // add user event listener for event
        // event types: load, queueStart, fileStart, fileComplete, queueComplete, progress, error, cancel
        eventName = eventName.toString().toLowerCase().replace(/^on/, '');
        if (!this.handlers[eventName]) this.handlers[eventName] = [];
        this.handlers[eventName].push(func);
    },

    setHandCursor: function (enabled) {
        // enable hand cursor (true), or default arrow cursor (false)
        this.handCursorEnabled = enabled;
        if (this.ready) this.movie.setHandCursor(enabled);
    },

    setCSSEffects: function (enabled) {
        // enable or disable CSS effects on DOM container
        this.cssEffects = !!enabled;
    },

    receiveEvent: function (eventName, args) {
        // receive event from flash
        eventName = eventName.toString().toLowerCase().replace(/^on/, '');

        // special behavior for certain events
        switch (eventName) {
            case 'load':
                // movie claims it is ready, but in IE this isn't always the case...
                // bug fix: Cannot extend EMBED DOM elements in Firefox, must use traditional function
                this.movie = document.getElementById(this.movieId);
                if (!this.movie) {
                    var self = this;
                    setTimeout(function () {
                        self.receiveEvent('load', null);
                    }, 1);
                    return;
                }

                // firefox on pc needs a "kick" in order to set these in certain cases
                if (!this.ready && navigator.userAgent.match(/Firefox/) && navigator.userAgent.match(/Windows/)) {
                    var self = this;
                    setTimeout(function () {
                        self.receiveEvent('load', null);
                    }, 100);
                    this.ready = true;
                    return;
                }

                this.ready = true;
                this.movie.clearText();
                this.movie.appendText(this.clipText);
                this.movie.setFileName(this.fileName);
                this.movie.setAction(this.action);
                this.movie.setCharSet(this.charSet);
                this.movie.setBomInc(this.incBom);
                this.movie.setHandCursor(this.handCursorEnabled);
                break;

            case 'mouseover':
                if (this.domElement && this.cssEffects) {
                    //this.domElement.addClass('hover');
                    if (this.recoverActive) this.domElement.addClass('active');
                }
                break;

            case 'mouseout':
                if (this.domElement && this.cssEffects) {
                    this.recoverActive = false;
                    if (this.domElement.hasClass('active')) {
                        this.domElement.removeClass('active');
                        this.recoverActive = true;
                    }
                    //this.domElement.removeClass('hover');
                }
                break;

            case 'mousedown':
                if (this.domElement && this.cssEffects) {
                    this.domElement.addClass('active');
                }
                break;

            case 'mouseup':
                if (this.domElement && this.cssEffects) {
                    this.domElement.removeClass('active');
                    this.recoverActive = false;
                }
                break;
        } // switch eventName

        if (this.handlers[eventName]) {
            for (var idx = 0, len = this.handlers[eventName].length; idx < len; idx++) {
                var func = this.handlers[eventName][idx];

                if (typeof(func) == 'function') {
                    // actual function reference
                    func(this, args);
                }
                else if ((typeof(func) == 'object') && (func.length == 2)) {
                    // PHP style object + method, i.e. [myObject, 'myMethod']
                    func[0][func[1]](this, args);
                }
                else if (typeof(func) == 'string') {
                    // name of function
                    window[func](this, args);
                }
            } // foreach event handler defined
        } // user defined handler for event
    }

};
